import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox'
import T from 'i18n-react'

import CollapseIconButton from 'components/fulcrum/collapse/CollapseIconButton'
import AddIconButton from './AddButton'

const Actions = ({toggleCollapse, collapse, onAddClick}) => {
  return (
    <Flex justify='flex-end'>
      <AddIconButton
        message={T.translate('pages.project.view.notification.addFile')}
        onClick={onAddClick}
      />
      <CollapseIconButton
        toggleCollapse={toggleCollapse}
        collapse={collapse}
      />
    </Flex>
  )
}

export default Actions
